module.exports = __webpack_public_path__ + "static/img/a026.76785b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a026.jpg
// module id = Djmh
// module chunks = 0